import React, { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { MessageOutlined } from "@material-ui/icons";

import { i18n } from "../../translate/i18n";
import { ModalImageCorsContext } from "../../context/ModalImageCors";
import truncateString from "../../utils/truncateString";

import DefaultValuesUtils from "../../utils/classes/DefaultValuesUtils";

const useStyles = makeStyles(theme => ({
  //  ********************
  //  ** Main Container **
  //  ********************
	adMainContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    justifyContent: "center",
    gap: "5px",
    marginBottom: "1em",
  },

  //  ******************************
  //  ** Identification Container **
  //  ******************************
  adIdentificationContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    fontSize: "12px",
    opacity: "0.75",
    fontStyle: "italic",
  },

  //  ********************
  //  ** Info Container **
  //  ********************
  adInfoContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    padding: "5px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    borderRadius: "5px",
    "&:hover": { opacity: "0.9", transform: "translateY(-5px)", },
  },

  adInfoContainerVariantMessage: {
    backgroundColor: theme.palette.background.paper,
  },

  adInfoContainerVariantStarred: {
    backgroundColor: theme.palette.text.primary,
    color: theme.palette.background.paper,
  },

  adInfoTextContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "3px",
    padding: "1em",
  },

  adInfoThumbnail: {
    width: "75px",
    height: "75px",
  },

  adInfoSourceUrl: {
    opacity: "0.80",
    fontSize: "14px",
  },
}));

const AdsMessage = ({ message, redirectFlag, variant = "message" }) => {
	// 	***************
	// 	** Variables **
	// 	***************
	const classes = useStyles();
  const { openImageModalCors } = useContext(ModalImageCorsContext);
  const [adInfoContainerClass, setAdInfoContainerClass] = useState("");



  //  *****************
  //  ** Use Effects **
  //  *****************
  useEffect(() => {
    const style = variant === "starred"
      ? `${classes.adInfoContainer} ${classes.adInfoContainerVariantStarred}`
      : `${classes.adInfoContainer} ${classes.adInfoContainerVariantMessage}`;

    setAdInfoContainerClass(style);
  }, [classes, variant]);




	// 	***************
	// 	** Functions **
	// 	***************
  const handleAdsRedirect = () => {
    if (!message.adsSourceUrl || !redirectFlag) return;
    window.open(message.adsSourceUrl, "_blank");    
  };

  const handleAdsImageView = () => {
    openImageModalCors(message.adsThumbnailUrl, null, false, message.isDeleted);
  };



	// 	************
	// 	** Return **
	// 	************
	return (
		<div className={classes.adMainContainer}>
      <div className={classes.adIdentificationContainer}>
        <MessageOutlined style={{fontSize: "18px"}} />
        <span>{i18n.t("adsComponent.identification")}</span>
      </div>

      <div className={adInfoContainerClass}>
        {message.adsThumbnailUrl && (
          <img className={classes.adInfoThumbnail} alt="ADS" src={message.adsThumbnailUrl} onClick={handleAdsImageView} />
        )}

        <div className={classes.adInfoTextContainer} onClick={handleAdsRedirect}>
          <span>{message.adsTitle ? truncateString(message.adsTitle, 30) : "-" }</span>
          <span className={classes.adInfoSourceUrl}>{message.adsConversionFrom || DefaultValuesUtils.ADS.adsConversionFrom}</span>
        </div>
      </div>
    </div>
	);
};

export default AdsMessage;
